import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M18.965 16.61L17.792 15.437C17.5107 15.1558 17.1293 14.9979 16.7315 14.9979C16.3338 14.9979 15.9523 15.1558 15.671 15.437L14.749 16.359C14.6493 16.4611 14.5212 16.5307 14.3814 16.5589C14.2415 16.5871 14.0965 16.5725 13.965 16.517C12.629 15.932 11.309 15.045 10.132 13.868C9.02336 12.7696 8.1276 11.4755 7.49002 10.051C7.43226 9.91526 7.41682 9.7652 7.44573 9.62051C7.47463 9.47581 7.54653 9.3432 7.65202 9.24004L8.47802 8.41404C9.14902 7.74304 9.14902 6.79404 8.56302 6.20804L7.39002 5.03504C7.01497 4.66009 6.50635 4.44946 5.97602 4.44946C5.4457 4.44946 4.93708 4.66009 4.56202 5.03504L3.91002 5.68604C3.16902 6.42704 2.86002 7.49604 3.06002 8.55604C3.55402 11.169 5.07202 14.03 7.52102 16.479C9.97002 18.928 12.831 20.446 15.444 20.94C16.504 21.14 17.573 20.831 18.314 20.09L18.965 19.439C19.1508 19.2533 19.2982 19.0328 19.3988 18.7901C19.4993 18.5474 19.5511 18.2872 19.5511 18.0245C19.5511 17.7618 19.4993 17.5017 19.3988 17.259C19.2982 17.0163 19.1508 16.7958 18.965 16.61Z',
                    fill: '#82869E',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M13 6.99101C13.5289 6.98232 14.0541 7.08009 14.5444 7.27852C15.0347 7.47694 15.48 7.77195 15.854 8.14601',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M18.682 5.31812C17.9366 4.57082 17.051 3.97816 16.0759 3.57419C15.1008 3.17022 14.0555 2.96289 13 2.96412',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M17.009 11C17.0177 10.4711 16.9199 9.94594 16.7215 9.45564C16.5231 8.96534 16.2281 8.51996 15.854 8.146',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M18.6821 5.31812C19.4294 6.06348 20.0221 6.94915 20.4261 7.92424C20.83 8.89934 21.0374 9.94465 21.0361 11.0001',
                    stroke: '#82869E',
                    strokeWidth: '1.5',
                    strokeMiterlimit: '10',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const PhoneFilled = React.forwardRef(IconComponent);
PhoneFilled.displayName = 'PhoneFilled';

export { PhoneFilled };
